import Layout from "@/components/feature/Layout";
import HeroSection from "./components/HeroSection";
import ServiceCardsSection from "./components/ServiceCardsSection";
import AboutSection from "./components/AboutSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ProcessSection from "./components/ProcessSection";
import RegionsSection from "./components/RegionsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import ContactFormSection from "./components/ContactFormSection";

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <ServiceCardsSection />
      <AboutSection />
      <WhyChooseSection />
      <ProcessSection />
      <RegionsSection />
      <CTASection />
      <FAQSection />
      <ContactFormSection />
    </Layout>
  );
}